import BaseNodeModel from "../BaseNodeModel";
import React from "react";
import ReactDOM from "react-dom";
import VariableSubstitutionDialog from "../../widgets/dialogs/VariableSubstitutionDialog";

export default class SampleDialogDataModel extends BaseNodeModel {
    constructor(name, props, id) {
        super(name, 0, 0, props, id);
        this.props.nodeTypeName = "Sample Dialog";
    }

    setConfig(key, value) {
        window.apm.setDialogConfig(this.id, key, value);
        super.setConfig(key, value);
    }

    getConfigViews() {
        const views = [
            { type: "Input", label: this.getPropLabel("name"), key: "name", valRules: {"noEmpty": true} },
            { type: "Textarea", label: this.getPropLabel("description"), key: "description" },
            { type: "Input", label: this.getPropLabel("jira_ticket_number"), key: "jira" },
            {
                type: "Dropdown", key: "promptVoice", label: "TTS prompt voice", optionName: "Select voice",
                options: window.apm.knowledgeBase.getTtsVoices()
            },
            {
                type: "Dropdown", key: "inputVoice", label: "TTS input voice", optionName: "Select voice",
                options: window.apm.knowledgeBase.getTtsVoices()
            },

        ];
        if (!this.isEmbed) {
            views.push(
                { type: "hr" },
                {
                    type: "Button", label: "Set variables for TTP/TTS", wide: true, callback: (event, buttonDom, context) => {
                        window.apm.popup("Substitute variable values",
                            '<div class="substitute_variable_container"></div>',
                            '<button class="w2ui-btn secondary" onclick="w2popup.close();">' + window.l.popup.close + '</button> ' +
                            '<button class="w2ui-btn primary add-button">Save</button> ',
                            [
                                ".substitute_variable_container",
                                () => {
                                    ReactDOM.render(<VariableSubstitutionDialog dialogId={this.id} />, $(".substitute_variable_container").get(0));
                                    $(".w2ui-popup").find(".add-button").on("click", function () {
                                        document.dispatchEvent(new CustomEvent("ev-var-substitute"));
                                    });
                                    
                                }    
                            ]
                            , 500
                        );
                    }
                }
            );
        }
        return views;
    }

    serialize() {
        return {
            id: this.getID(),
            name: this.getConfig("name"),
            description: this.getConfig("description"),
            jira: this.getConfig("jira"),
            promptVoice: this.getConfig("promptVoice"),
            inputVoice: this.getConfig("inputVoice"),
            nodes: [],
            substitutions: {}
        }
    }
}